// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ConditionalFieldController from "./conditional_field_controller"
application.register("conditional-field", ConditionalFieldController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import RemoteSelectController from "./remote_select_controller"
application.register("remote-select", RemoteSelectController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import VolumeUnitController from "./volume_unit_controller"
application.register("volume-unit", VolumeUnitController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import LabelEntryFormController from "./label_entry_form_controller"
application.register("label-entry-form", LabelEntryFormController)

import CropSearchController from "./crop_search_controller"
application.register("crop-search", CropSearchController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import VoiceApplicationController from "./voice_application_controller"
application.register("voice-application", VoiceApplicationController)
